{
  "de": {
    "validations": {
      "dialogFormat": "Bitte kennzeichne die beiden Sprecher mit **Name**: am Zeilenanfang, gefolgt vom gesprochenen Text. Eine Zeile pro Sprechbeitrag und keine weiteren **-Markierungen im Text.",
      "email": "Bitte gib eine gültige E-Mail-Adresse ein.",
      "embeddedAppNotFound": "Der eingebundene Inhalt konnte nicht gefunden werden.",
      "groupCountTooLarge": "Die Anzahl der Gruppen muss unter der Anzahl der Namen liegen.",
      "groupSizeTooLarge": "Die Anzahl der Mitglieder pro Gruppe muss unter der Anzahl der Namen liegen.",
      "groupSizeTooSmall": "Die Anzahl deiner Gruppen liegt über dem Maximum von 20. Erhöhe die Anzahl der Mitglieder pro Gruppe oder senke die Anzahl der Namen.",
      "integer": "Bitte gib eine ganze Zahl ein.",
      "isYoutubeOrVimeoUrl": "Bitte gib eine gültige YouTube oder Vimeo URL ein.",
      "linkedAppNotFound": "Der verlinkte Inhalt konnte nicht gefunden werden.",
      "maxLength": "Maximal {max} auswählbar",
      "maxLengthValue": "Maximale Länge ist {max} Zeichen.",
      "minLength": "Mindestens {min} Buchstaben",
      "namesCountTooLarge": "Du kannst maximal 100 Namen eingeben.",
      "namesCountTooSmall": "Du musst mindestens zwei Namen eingeben.",
      "required": "Dieses Feld ist ein Pflichtfeld.",
      "requiredIf": "Dieses Feld ist ein Pflichtfeld.",
      "tooManyWords": "Bitte gib maximal {count} Wörter ein.",
      "url": "Bitte gib eine gültige URL (inkl. https://) ein.",
      "validEmbedCode": "Bitte gib eine gültige URL oder ein iFrame-Code-Snippet ein.",
      "validUrl": "Bitte gib eine gültige URL ein.",
      "maxValue": "Der Wert darf maximal {max} betragen.",
      "minValue": "Der Wert muss mindestens {min} betragen.",
      "youtubeOrVimeoUrl": "Bitte gib eine gültige YouTube- oder Vimeo-URL ein."
    }
  }
}
